/**
 * Check greater than or equal
 *
 * @see https://voltaire.tevm.sh/primitives/uint128 for Uint128 documentation
 * @since 0.0.0
 * @param {import('./Uint128Type.js').Uint128Type} uint - First operand
 * @param {import('./Uint128Type.js').Uint128Type} b - Second operand
 * @returns {boolean} True if uint >= b
 * @throws {never}
 * @example
 * ```javascript
 * import * as Uint128 from './primitives/Uint128/index.js';
 * const a = Uint128.from(100n);
 * const b = Uint128.from(100n);
 * Uint128.greaterThanOrEqual(a, b); // true
 * ```
 */
export function greaterThanOrEqual(uint, b) {
	return uint >= b;
}
